import { render } from "./BaseCheckboxDropdown.vue?vue&type=template&id=94b7a824"
import script from "./BaseCheckboxDropdown.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__